export default __webpack_public_path__ + "static/media/330_business01-en-web.3d90e0ef.png";